export class I18nModule {

  static init() {

    window.L = (key, placeholders) => I18nModule.translate(key, placeholders);

  }

  static translate(key, placeholders) {

    if(placeholders === undefined) placeholders = {};
  
    if (window.languageKeys[key] === undefined) {
      return `<span style='color: red'>${key}</span>`;
    }
  
    let text = window.languageKeys[key];
    for (const ix in placeholders) {
      const value = placeholders[ix];
      text = text.replaceAll(ix, value);
    }
  
    return text;

  }

}